import { ErrorCode } from './ErrorCode';
import type { ErrorCodeMessageType } from './ErrorCodeMessageType';

export class BizError extends Error {
  private errorCodeMessageType: ErrorCodeMessageType;

  constructor(error?: Error | ErrorCodeMessageType | ErrorCode, errorMessage?: string) {
    super();

    this.errorCodeMessageType = this.errorToErrorCodeMessageType(
      error,
      errorMessage ? `: ${errorMessage}` : undefined,
    );
    Error.captureStackTrace(this, this.constructor);
  }

  private errorToErrorCodeMessageType(
    error?: Error | ErrorCodeMessageType | ErrorCode,
    errorMessage = '',
  ): ErrorCodeMessageType {
    if (!error || error instanceof Error) {
      return {
        errorCode: ErrorCode.Unknown,
        errorMessage: (error?.message ?? 'Unknown Error') + errorMessage,
      };
    } else if (typeof error === 'object') {
      return error;
    } else {
      if (error === ErrorCode.Unknown) {
        return {
          errorCode: error,
          errorMessage: 'Unknown Error ' + errorMessage,
        };
      } else if (error === ErrorCode.NetworkError) {
        return {
          errorCode: error,
          errorMessage: 'Network Error ' + errorMessage,
        };
      } else {
        return {
          errorCode: error,
        };
      }
    }
  }

  public getErrorCodeMessageType(): ErrorCodeMessageType {
    return this.errorCodeMessageType;
  }
}
